import * as React from "react";
import { RichTextArea } from "@grandvisionhq/common";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachRichText } from "../../../../hooks/hooks/use-bloomreach-rich-text.js";
const CmsDocument = ({ content }) => {
  const richText = useBloomreachRichText(content.content?.value);
  if (!richText) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(RichTextArea, { content: richText });
};
const Document = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsDocument);
export {
  CmsDocument,
  Document as default
};
//# sourceMappingURL=Document.js.map
